export default __webpack_public_path__ + "static/media/199.0216cd51.png";